import {
  useWSSnackbar,
  WSActions,
  WSAvatar,
  WSDropFileInput,
  WSElement,
  WSFlexBox,
  WSIcon,
  WSText
} from "@wingspanhq/fe-component-library";
import React, { useRef, useState } from "react";
import { useMutationMemberPrivateFileCreate } from "../../../../../query/files/mutations";
import { WSErrorMessage } from "../../../../../components/WSErrorMessage/WSErrorMessage";
import { ErrorContextKey } from "../../../../../services/platform";

interface UploadDocumentModalProps {
  onClose(): void;
  onSuccess(props: { fileId: string }): void;
  accept?: string | string[];
}

export const ModalUploadFile: React.FC<UploadDocumentModalProps> = ({
  onClose,
  onSuccess,
  accept = "image/*, .pdf"
}) => {
  const [fileToUpload, setFileToUpload] = useState<File>();
  const { openSnackbar } = useWSSnackbar();
  const uploadContainerElement = useRef<HTMLElement>(null);

  const [uploadFile, uploadFileMeta] = useMutationMemberPrivateFileCreate({
    hidden: true
  });

  const onUpload = async () => {
    if (fileToUpload) {
      const data = new FormData();
      data.append("file", fileToUpload);
      await uploadFile(data, {
        onSuccess: files => {
          setFileToUpload(undefined);
          openSnackbar({
            message: "File uploaded successfully",
            type: "success"
          });
          const fileId = files[0].fileId;
          onSuccess({ fileId });
          onClose();
        }
      });
    }
  };

  return (
    <WSElement>
      <WSElement mb="XL" ref={uploadContainerElement}>
        <WSDropFileInput
          name="test"
          buttonText="Choose a file"
          onDropAccepted={(accepted: File[]) => {
            setFileToUpload(accepted[0]);
          }}
          accept={accept}
        />
        {fileToUpload && (
          <>
            <WSElement mb="M" p="S">
              <WSFlexBox.CenterY wrap="nowrap">
                <WSAvatar.Icon
                  icon="paperclip"
                  mr="M"
                  color="green500"
                  colorBackground="green50"
                />
                <WSText.ParagraphSm singleLine>
                  {fileToUpload.name}
                </WSText.ParagraphSm>
                <WSIcon
                  block
                  color="gray500"
                  size="XS"
                  mx="M"
                  name="exit"
                  onClick={() => {
                    setFileToUpload(undefined);
                  }}
                />
              </WSFlexBox.CenterY>
            </WSElement>
          </>
        )}
      </WSElement>

      <WSErrorMessage
        contextKey={ErrorContextKey.UploadDocument}
        error={uploadFileMeta.error}
        mb="M"
      />
      <WSActions
        alignment="fill"
        buttons={[
          {
            kind: "Secondary",
            label: "Cancel",
            onClick: onClose,
            type: "button"
          },
          {
            loading: uploadFileMeta.isLoading,
            disabled: !fileToUpload,
            kind: "Primary",
            onClick: onUpload,
            type: "button",
            label: "Upload"
          }
        ]}
      />
    </WSElement>
  );
};
